import { memo, useCallback, useMemo } from 'react';
import {
  BottomSheet,
  StackNavigationProp,
  useNavigation,
} from '@bonanza-social/navigation';
import DailyGiftAwarded from '../DailyGiftAwarded/DailyGiftAwarded';
import DailyGiftPending from '../DailyGiftPending/DailyGiftPending';
import { claimDailyGift } from '../../state/dailyGift.slice';
import { useDispatch } from '@bonanza-social/toolkit/state';
import useDailyGift from '../../hooks/useDailyGift';
function DailyGift() {
  const dispatch = useDispatch();
  const { dailyGift, dailyGiftStatus, claimDailyGiftDataState } =
    useDailyGift();

  const isLocked = useMemo(
    () => dailyGiftStatus === 'NotAvailable',
    [dailyGiftStatus],
  );

  const handleClaim = useCallback(() => {
    if (dailyGift?.playerRewardId) {
      dispatch(claimDailyGift(dailyGift.playerRewardId));
    }
  }, [dailyGift, dispatch]);

  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const handleGoToGames = () => {
    navigation.navigate('PlayWithCoinsScreen');
  };

  const handleUnlock = useCallback(() => {
    BottomSheet.open({
      namespace: 'dailyGift',
      type: 'DailyGiftLocked',
    });
  }, []);

  if (isLocked) {
    return (
      <DailyGiftPending
        type="locked"
        isClaiming={false}
        onPress={handleUnlock}
      />
    );
  }

  if (dailyGiftStatus === 'Pending') {
    return (
      <DailyGiftPending
        type="pending"
        isClaiming={Boolean(claimDailyGiftDataState.match('pending'))}
        onPress={handleClaim}
      />
    );
  }

  if (dailyGiftStatus === 'Awarded' && dailyGift?.rewardAmount) {
    return (
      <DailyGiftAwarded
        rewardAmount={dailyGift?.rewardAmount}
        nextAvailableAt={dailyGift?.nextAvailableAt}
        handleGoToShop={handleGoToGames}
      />
    );
  }

  return null;
}

export default memo(DailyGift);
